import styled from 'styled-components';
import Input from '@mui/material/Input';

export const Textarea = styled(Input)`
  display: flex;
  width: 100%;
  font-weight: 400;
  line-height: 1.4375em;
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => props.theme.input.border};
  border-radius: 4px;
  background: ${(props) => props.theme.input.background};

  &:hover,
  &:focus,
  &.Mui-focused {
    border-color: ${(props) => props.theme.input.border};
    box-shadow: 0 0 0 3px rgba(202, 191, 253, 0.45);
  }

  textarea {
    padding: 8.5px 14px;
  }

  &:before,
  &:after {
    display: none;
  }

  .MuiInputBase-input {
    &.Mui-disabled {
      opacity: 0.4;
    }

    &::placeholder {
      color: ${(props) => props.theme.input.placeholder};
      opacity: 1;
    }
  }
`;
